module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/41BGPU/tc-custom/9781637158593.jpg?1710357513575",
      "alt": "This image is the cover for the book Blink, Blink"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blink, Blink\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Wren Booker was three when she was found alone and covered in blood on the streets of New York. Since that day, she’s been haunted by the childhood she can't remember…until decades later when she finds a cryptic website streaming multiple CCT feeds from strange rooms in a ruined building. Something clicks, setting off hidden memories that lead her back to a place she’s seen in lifelong nightmares. Hunting for answers, Wren breaks in and finds herself lost in the camera-filled dark mazes of a decayed social experiment known only as BLINK...which she quickly discovers is not abandoned at all. But what should be a foreign nightmare-scape feels all too familiar for Wren as she follows her obsession all the way down, piecing together the story of BLINK—as well as her own ties to it. Eisner-nominated Christopher Sebela (Dirtbag Rapture), Hayden Sherman (Dark Spaces: Wildfire), and Nick Filardi (Rogue Planet) team up for a found-footage horror where uncovering your past will leave you trapped inside it.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christopher Sebela, Hayden Sherman, Nick Filardi, Frank Cvetkovic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Christopher Sebela is a four-time Eisner-nominated writer, designer, and publisher. He’s the co-creator of Crowded, Dead Dudes, Test, Heartthrob, and Shanghai Red, among others. He puts out his weirder work himself via a tiny publishing empire called Two Headed Press. Go see him at www.christophersebela.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0